import { Box, CircularProgress, Paper, Typography } from '@material-ui/core'

import { FieldInfo } from '@/pages/maps/contexts/region-context'

import { FieldsList } from '../fields-list'
import ListHeader from '../fields-list/list-header'
import { useStyles } from './styles'

export interface WrapperFieldsListProps {
  items: (FieldInfo & { checked: boolean })[]
  title: string
  defaultText: string
  onToggle: (id: string) => void
  isLoading?: boolean
}

export default function WrapperFieldsList({
  items,
  title,
  defaultText,
  onToggle,
  isLoading = false,
}: WrapperFieldsListProps) {
  const classes = useStyles()

  const handleToggle = (id: string) => {
    onToggle(id)
  }

  const nItems = items.length
  const isEmpty = nItems === 0
  const calcHeight = 90 + nItems * 38

  const paperStyle: React.CSSProperties = {
    opacity: isEmpty ? 0.5 : 1,
    minHeight: isEmpty ? '90px' : calcHeight < 160 ? calcHeight : 160,
    maxHeight: calcHeight,
  }

  return (
    <Paper className={classes.wrapperFieldsListContainer} style={paperStyle}>
      <Typography variant='subtitle2' className={classes.titleContainer}>
        {title}
      </Typography>

      <Box className={classes.formContainer}>
        {isLoading ? (
          <Box className={classes.loadingContainer}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          !isEmpty && (
            <Box className={classes.formGroup}>
              <ListHeader />
              <FieldsList items={items} onToggle={handleToggle} />
            </Box>
          )
        )}
      </Box>

      <Typography
        variant='subtitle2'
        hidden={!isEmpty || isLoading}
        className={classes.defaultText}
      >
        {defaultText}
      </Typography>
    </Paper>
  )
}
